// Port of api/fuel/app/classes/filter/core/search/unit.php
// Base helper functions shared by all filter and sort classes.

// Check if a sort name is active in the filter's sort string.
// Returns 1-based position, or 0 if not found.
export function sorted(name, filter) {
	if (!Array.isArray(name)) name = [name]
	if (!filter.sort) return 0
	var sorts = filter.sort.split(',')
	for (var i = 0; i < sorts.length; i++) {
		var s = sorts[i].replace(/^[+-]/, '')
		if (name.indexOf(s) !== -1) return i + 1
	}
	return 0
}

// Check if a sort is reversed (prefixed with -)
export function sortReverse(name, filter) {
	if (!Array.isArray(name)) name = [name]
	if (!filter.sort) return false
	var sorts = filter.sort.split(',')
	var reversedCount = 0
	for (var i = 0; i < sorts.length; i++) {
		var s = sorts[i]
		if (name.indexOf(s.replace(/^[+-]/, '')) !== -1) {
			if (s.charAt(0) === '-') reversedCount++
		}
	}
	return reversedCount || (name.indexOf(filter.sort) !== -1 && filter.sortReverse)
}

// Get the priority (1-based position) of a sort in the sort string.
export function sortPriority(name, filter, def) {
	if (!Array.isArray(name)) name = [name]
	def = (def !== undefined) ? def : 10000
	if (!filter.sort) return def
	var sorts = filter.sort.split(',')
	for (var i = 0; i < sorts.length; i++) {
		var s = sorts[i].replace(/^[+-]/, '')
		if (name.indexOf(s) !== -1) return i + 1
	}
	return def
}

// Check if a range filter differs from its default bounds.
export function rangeActive(val, defFrom, defTo) {
	return val && (val.from !== defFrom || val.to !== defTo)
}
